export default __webpack_public_path__ + "static/media/thomas.ba65ad15.jpeg";